import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d1a140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex-column" }
const _hoisted_2 = { class: "top-wrap d-flex" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "捐款总额（元）", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "捐款次数（次）", -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "捐款物资（件）", -1))
const _hoisted_9 = { class: "d-flex-1f body d-overflow-not" }
const _hoisted_10 = { class: "d-overflow d-full" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-title" }, "捐款项目", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Project = _resolveComponent("Project")!
  const _component_app_list = _resolveComponent("app-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "d-flex-1f top-l",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDonnationParm(0)))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.totalPoints), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", {
        class: "d-flex-1f top-m",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDonnationParm(1)))
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.donnitonCount), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", {
        class: "d-flex-1f top-r",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDonnationParm(2)))
      }, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.suppliesCount), 1),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_app_list, {
          onLoadData: _ctx.Search,
          ref: "appList"
        }, {
          default: _withCtx((slotProps) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.list, (item) => {
              return (_openBlock(), _createBlock(_component_Project, {
                key: item.id,
                data: item
              }, null, 8, ["data"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onLoadData"])
      ])
    ])
  ]))
}